export default __webpack_public_path__ + "static/media/maze3.0fb5fca7.png";